/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AddUserPermissionRequest,
    AddUserPermissionRequestFromJSON,
    AddUserPermissionRequestToJSON,
} from '../models/AddUserPermissionRequest';
import {
    type AddUserRoleRequest,
    AddUserRoleRequestFromJSON,
    AddUserRoleRequestToJSON,
} from '../models/AddUserRoleRequest';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/ProblemDetails';
import {
    type SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/SortOrder';
import {
    type UserAccessAndClaimsResponse,
    UserAccessAndClaimsResponseFromJSON,
    UserAccessAndClaimsResponseToJSON,
} from '../models/UserAccessAndClaimsResponse';
import {
    type UserAccessResponse,
    UserAccessResponseFromJSON,
    UserAccessResponseToJSON,
} from '../models/UserAccessResponse';
import {
    type UserDto,
    UserDtoFromJSON,
    UserDtoToJSON,
} from '../models/UserDto';
import {
    type UserEventRequestSearchOrderBy,
    UserEventRequestSearchOrderByFromJSON,
    UserEventRequestSearchOrderByToJSON,
} from '../models/UserEventRequestSearchOrderBy';
import {
    type UserEventResponse,
    UserEventResponseFromJSON,
    UserEventResponseToJSON,
} from '../models/UserEventResponse';
import {
    type UserEventResponsePagedResult,
    UserEventResponsePagedResultFromJSON,
    UserEventResponsePagedResultToJSON,
} from '../models/UserEventResponsePagedResult';

export interface ApiUsersUserIdAccessClaimsGetRequest {
    userId: string;
}

export interface ApiUsersUserIdAccessGetRequest {
    userId: string;
}

export interface ApiUsersUserIdB2cInfoGetRequest {
    userId: string;
}

export interface ApiUsersUserIdDeleteRequest {
    userId: string;
}

export interface ApiUsersUserIdEventsPagedPostRequest {
    userId: string;
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: UserEventRequestSearchOrderBy;
}

export interface ApiUsersUserIdEventsPostRequest {
    userId: string;
}

export interface ApiUsersUserIdGetRequest {
    userId: string;
}

export interface ApiUsersUserIdPermissionsPermissionIdDeleteRequest {
    userId: string;
    permissionId: number;
}

export interface ApiUsersUserIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRequest {
    userId: string;
    permissionId: number;
    organizationId: number;
}

export interface ApiUsersUserIdPermissionsPostRequest {
    userId: string;
    addUserPermissionRequest: AddUserPermissionRequest;
}

export interface ApiUsersUserIdRolesPostRequest {
    userId: string;
    addUserRoleRequest: AddUserRoleRequest;
}

export interface ApiUsersUserIdRolesRoleIdDeleteRequest {
    userId: string;
    roleId: number;
}

export interface ApiUsersUserIdRolesRoleIdOrganizationOrganizationIdDeleteRequest {
    userId: string;
    roleId: number;
    organizationId: number;
}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiUsersUserIdAccessClaimsGet without sending the request
     */
    async apiUsersUserIdAccessClaimsGetRequestOpts(requestParameters: ApiUsersUserIdAccessClaimsGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdAccessClaimsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/users/{userId}/access/claims`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUsersUserIdAccessClaimsGetRaw(requestParameters: ApiUsersUserIdAccessClaimsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserAccessAndClaimsResponse>>> {
        const requestOptions = await this.apiUsersUserIdAccessClaimsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserAccessAndClaimsResponseFromJSON));
    }

    /**
     */
    async apiUsersUserIdAccessClaimsGet(requestParameters: ApiUsersUserIdAccessClaimsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserAccessAndClaimsResponse>> {
        const response = await this.apiUsersUserIdAccessClaimsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiUsersUserIdAccessGet without sending the request
     */
    async apiUsersUserIdAccessGetRequestOpts(requestParameters: ApiUsersUserIdAccessGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdAccessGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/users/{userId}/access`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUsersUserIdAccessGetRaw(requestParameters: ApiUsersUserIdAccessGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserAccessResponse>>> {
        const requestOptions = await this.apiUsersUserIdAccessGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserAccessResponseFromJSON));
    }

    /**
     */
    async apiUsersUserIdAccessGet(requestParameters: ApiUsersUserIdAccessGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserAccessResponse>> {
        const response = await this.apiUsersUserIdAccessGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiUsersUserIdB2cInfoGet without sending the request
     */
    async apiUsersUserIdB2cInfoGetRequestOpts(requestParameters: ApiUsersUserIdB2cInfoGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdB2cInfoGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/users/{userId}/b2c-info`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUsersUserIdB2cInfoGetRaw(requestParameters: ApiUsersUserIdB2cInfoGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiUsersUserIdB2cInfoGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiUsersUserIdB2cInfoGet(requestParameters: ApiUsersUserIdB2cInfoGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUsersUserIdB2cInfoGetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiUsersUserIdDelete without sending the request
     */
    async apiUsersUserIdDeleteRequestOpts(requestParameters: ApiUsersUserIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/users/{userId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUsersUserIdDeleteRaw(requestParameters: ApiUsersUserIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiUsersUserIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiUsersUserIdDelete(requestParameters: ApiUsersUserIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUsersUserIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiUsersUserIdEventsPagedPost without sending the request
     */
    async apiUsersUserIdEventsPagedPostRequestOpts(requestParameters: ApiUsersUserIdEventsPagedPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdEventsPagedPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/users/{userId}/events-paged`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUsersUserIdEventsPagedPostRaw(requestParameters: ApiUsersUserIdEventsPagedPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserEventResponsePagedResult>> {
        const requestOptions = await this.apiUsersUserIdEventsPagedPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserEventResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiUsersUserIdEventsPagedPost(requestParameters: ApiUsersUserIdEventsPagedPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserEventResponsePagedResult> {
        const response = await this.apiUsersUserIdEventsPagedPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiUsersUserIdEventsPost without sending the request
     */
    async apiUsersUserIdEventsPostRequestOpts(requestParameters: ApiUsersUserIdEventsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdEventsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/users/{userId}/events`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUsersUserIdEventsPostRaw(requestParameters: ApiUsersUserIdEventsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserEventResponse>>> {
        const requestOptions = await this.apiUsersUserIdEventsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserEventResponseFromJSON));
    }

    /**
     */
    async apiUsersUserIdEventsPost(requestParameters: ApiUsersUserIdEventsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserEventResponse>> {
        const response = await this.apiUsersUserIdEventsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiUsersUserIdGet without sending the request
     */
    async apiUsersUserIdGetRequestOpts(requestParameters: ApiUsersUserIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/users/{userId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUsersUserIdGetRaw(requestParameters: ApiUsersUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserDto>> {
        const requestOptions = await this.apiUsersUserIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiUsersUserIdGet(requestParameters: ApiUsersUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserDto> {
        const response = await this.apiUsersUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiUsersUserIdPermissionsPermissionIdDelete without sending the request
     */
    async apiUsersUserIdPermissionsPermissionIdDeleteRequestOpts(requestParameters: ApiUsersUserIdPermissionsPermissionIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdPermissionsPermissionIdDelete().'
            );
        }

        if (requestParameters['permissionId'] == null) {
            throw new runtime.RequiredError(
                'permissionId',
                'Required parameter "permissionId" was null or undefined when calling apiUsersUserIdPermissionsPermissionIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/users/{userId}/permissions/{permissionId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace('{permissionId}', encodeURIComponent(String(requestParameters['permissionId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUsersUserIdPermissionsPermissionIdDeleteRaw(requestParameters: ApiUsersUserIdPermissionsPermissionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiUsersUserIdPermissionsPermissionIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiUsersUserIdPermissionsPermissionIdDelete(requestParameters: ApiUsersUserIdPermissionsPermissionIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUsersUserIdPermissionsPermissionIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiUsersUserIdPermissionsPermissionIdOrganizationOrganizationIdDelete without sending the request
     */
    async apiUsersUserIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRequestOpts(requestParameters: ApiUsersUserIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdPermissionsPermissionIdOrganizationOrganizationIdDelete().'
            );
        }

        if (requestParameters['permissionId'] == null) {
            throw new runtime.RequiredError(
                'permissionId',
                'Required parameter "permissionId" was null or undefined when calling apiUsersUserIdPermissionsPermissionIdOrganizationOrganizationIdDelete().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling apiUsersUserIdPermissionsPermissionIdOrganizationOrganizationIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/users/{userId}/permissions/{permissionId}/organization/{organizationId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace('{permissionId}', encodeURIComponent(String(requestParameters['permissionId'])));
        urlPath = urlPath.replace('{organizationId}', encodeURIComponent(String(requestParameters['organizationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUsersUserIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRaw(requestParameters: ApiUsersUserIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiUsersUserIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiUsersUserIdPermissionsPermissionIdOrganizationOrganizationIdDelete(requestParameters: ApiUsersUserIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUsersUserIdPermissionsPermissionIdOrganizationOrganizationIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiUsersUserIdPermissionsPost without sending the request
     */
    async apiUsersUserIdPermissionsPostRequestOpts(requestParameters: ApiUsersUserIdPermissionsPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdPermissionsPost().'
            );
        }

        if (requestParameters['addUserPermissionRequest'] == null) {
            throw new runtime.RequiredError(
                'addUserPermissionRequest',
                'Required parameter "addUserPermissionRequest" was null or undefined when calling apiUsersUserIdPermissionsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/users/{userId}/permissions`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddUserPermissionRequestToJSON(requestParameters['addUserPermissionRequest']),
        };
    }

    /**
     */
    async apiUsersUserIdPermissionsPostRaw(requestParameters: ApiUsersUserIdPermissionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.apiUsersUserIdPermissionsPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiUsersUserIdPermissionsPost(requestParameters: ApiUsersUserIdPermissionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.apiUsersUserIdPermissionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiUsersUserIdRolesPost without sending the request
     */
    async apiUsersUserIdRolesPostRequestOpts(requestParameters: ApiUsersUserIdRolesPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdRolesPost().'
            );
        }

        if (requestParameters['addUserRoleRequest'] == null) {
            throw new runtime.RequiredError(
                'addUserRoleRequest',
                'Required parameter "addUserRoleRequest" was null or undefined when calling apiUsersUserIdRolesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/users/{userId}/roles`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddUserRoleRequestToJSON(requestParameters['addUserRoleRequest']),
        };
    }

    /**
     */
    async apiUsersUserIdRolesPostRaw(requestParameters: ApiUsersUserIdRolesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        const requestOptions = await this.apiUsersUserIdRolesPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiUsersUserIdRolesPost(requestParameters: ApiUsersUserIdRolesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.apiUsersUserIdRolesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiUsersUserIdRolesRoleIdDelete without sending the request
     */
    async apiUsersUserIdRolesRoleIdDeleteRequestOpts(requestParameters: ApiUsersUserIdRolesRoleIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdRolesRoleIdDelete().'
            );
        }

        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling apiUsersUserIdRolesRoleIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/users/{userId}/roles/{roleId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUsersUserIdRolesRoleIdDeleteRaw(requestParameters: ApiUsersUserIdRolesRoleIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiUsersUserIdRolesRoleIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiUsersUserIdRolesRoleIdDelete(requestParameters: ApiUsersUserIdRolesRoleIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUsersUserIdRolesRoleIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiUsersUserIdRolesRoleIdOrganizationOrganizationIdDelete without sending the request
     */
    async apiUsersUserIdRolesRoleIdOrganizationOrganizationIdDeleteRequestOpts(requestParameters: ApiUsersUserIdRolesRoleIdOrganizationOrganizationIdDeleteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiUsersUserIdRolesRoleIdOrganizationOrganizationIdDelete().'
            );
        }

        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling apiUsersUserIdRolesRoleIdOrganizationOrganizationIdDelete().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling apiUsersUserIdRolesRoleIdOrganizationOrganizationIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/users/{userId}/roles/{roleId}/organization/{organizationId}`;
        urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace('{roleId}', encodeURIComponent(String(requestParameters['roleId'])));
        urlPath = urlPath.replace('{organizationId}', encodeURIComponent(String(requestParameters['organizationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUsersUserIdRolesRoleIdOrganizationOrganizationIdDeleteRaw(requestParameters: ApiUsersUserIdRolesRoleIdOrganizationOrganizationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiUsersUserIdRolesRoleIdOrganizationOrganizationIdDeleteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiUsersUserIdRolesRoleIdOrganizationOrganizationIdDelete(requestParameters: ApiUsersUserIdRolesRoleIdOrganizationOrganizationIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUsersUserIdRolesRoleIdOrganizationOrganizationIdDeleteRaw(requestParameters, initOverrides);
    }

}
